export default "__VITE_ASSET__6e6a7763__"